module.exports = __webpack_public_path__ + "static/media/machine-empty.c489c5da.svg";